import { render } from "./GMSuppliersTab.vue?vue&type=template&id=3d49d0a6&scoped=true"
import script from "./GMSuppliersTab.vue?vue&type=script&lang=js"
export * from "./GMSuppliersTab.vue?vue&type=script&lang=js"

import "./GMSuppliersTab.vue?vue&type=style&index=0&id=3d49d0a6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d49d0a6"],['__file',"src/views/Products/GMWorkFlow/GMSuppliersTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d49d0a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d49d0a6', __exports__)) {
    api.reload('3d49d0a6', __exports__)
  }
  
  module.hot.accept("./GMSuppliersTab.vue?vue&type=template&id=3d49d0a6&scoped=true", () => {
    api.rerender('3d49d0a6', render)
  })

}


export default __exports__